<template>
	<section>
		<vue-json-pretty
	      :path="'res'"
	      :data="firmFirm">
	    </vue-json-pretty>
	</section>
</template>
<script>
import { ViewService } from "@/services/view.service";
import VueJsonPretty from 'vue-json-pretty'
export default {
	components: { VueJsonPretty },
    data: () => ({
    	firmFirm: ['loading']
    }),
    methods: {
    	getFirmFirm() {
    		ViewService.firmFirm().then(response => {
    			this.firmFirm = response;
    		});
    	}
    },
    mounted() {
    	this.getFirmFirm();
    }
};
</script>



// WEBPACK FOOTER //
// src/components/View/FirmFirm.vue